
import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import StrategiesTable from "@/components/admin/StrategiesTable";
import { StrategyProvider, StrategyWithDetails } from "@/types/strategy-types";

interface StrategiesTabProps {
  strategies: StrategyWithDetails[];
  providers: StrategyProvider[];
  toggleStrategyStatus: (strategyId: string, currentStatus: boolean) => Promise<void>;
  createStrategy: (strategy: Partial<StrategyWithDetails>) => Promise<void>;
  updateStrategy: (id: string, strategy: Partial<StrategyWithDetails>) => Promise<void>;
  deleteStrategy: (id: string) => Promise<void>;
  toggleStrategyActive: (strategyId: string, currentActive: boolean) => Promise<void>;
  approveStrategy: (strategyId: string, approved: boolean) => Promise<void>;
  userRole?: string | null;
}

const StrategiesTab = ({
  strategies,
  providers,
  toggleStrategyStatus,
  createStrategy,
  updateStrategy,
  deleteStrategy,
  toggleStrategyActive,
  approveStrategy,
  userRole
}: StrategiesTabProps) => {
  return (
    <TabsContent value="strategies">
      <StrategiesTable 
        strategies={strategies}
        providers={providers}
        onToggleStatus={toggleStrategyStatus}
        onToggleActive={toggleStrategyActive}
        onCreateStrategy={createStrategy}
        onUpdateStrategy={updateStrategy}
        onDeleteStrategy={deleteStrategy}
        onApproveStrategy={approveStrategy}
        userRole={userRole}
      />
    </TabsContent>
  );
};

export default StrategiesTab;
